<template>
    <div></div>
  </template>
  
  <style lang="scss" scoped></style>
  
  <script lang="ts">
  import { Component, Vue } from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as userService from "@/service/userService";
  import environment from "@/environment";
  
  @Component
  export default class SmeOss extends BaseComponent {
  
    async mounted() {
      const user = userService.isSignedIn();
  
      if (user) {
        if (this.isCustomer() || this.isCustomerUser() || this.isViewUser()) {
          this.$router.replace("/meetings");
        } else if (this.isManager()) {
          this.$router.replace("/customers");
        } else if (this.isUserAdmin()) {
          this.$router.replace("/dashboard");
        }
      } else {
        // check link sso
        const uid = this.$route.query.oneSmeUUID as string;
        const token = this.$route.query.oneSmeToken as string;
        console.log(uid);
        
        if(uid && token) {
            location.href = 'https://idp-sme.vnpt.vn/oauth2/authorize?response_type=code&client_id=OzElOq7JW1NKtfgpnafe0fbzwGoa&scope=openid&redirect_uri=https://econference.devitkv2.com/app';
        }
        else {
            location.href = environment.appBaseUrl;
        }
      }
    }
  }
  </script>
  